module.exports = __webpack_public_path__ + "static/media/md-man.b5efbf60.svg";